import { Reveal, Chapter } from "./shared";

const steps = [
  {
    t: "Create your Source Code",
    b: "Birth date, place, time. Your baseline rhythm, computed on your phone.",
  },
  {
    t: "Read your day",
    b: "One score, your best windows, and a short read of how today is moving.",
  },
  {
    t: "Add your people",
    b: "Both days, side by side. The right hour to talk.",
  },
];

export const HowItWorks = () => (
  <section id="how" className="py-16 sm:py-24 lg:py-32 bg-[#F2F0EB] text-[#0B0B0C]" data-testid="how-it-works-section">
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <Reveal>
        <Chapter num="07" label="Three steps" />
      </Reveal>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#0B0B0C]/15 border border-[#0B0B0C]/15">
        {steps.map((s, i) => (
          <Reveal key={s.t} delay={i * 0.12} className="bg-[#F2F0EB] p-6 sm:p-8 lg:p-12 hover:bg-[#ECEAE3] transition-colors duration-500" data-testid={`how-it-works-step-${i + 1}`}>
            <span className="h-heavy text-5xl text-[#FF4D0A]">{i + 1}</span>
            <h3 className="font-display font-bold text-2xl mt-6 mb-3 uppercase tracking-tight">{s.t}</h3>
            <p className="text-[#55585E] leading-relaxed">{s.b}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
